var main = require('./main');
// Get zipcode from param or the cookies if a dev server, for local use 90210
var zipcode = '';
// Defining dealer element to add zipcode prop
var dealerElement = document.getElementsByTagName('dealer-locator-container')[0];
// Defining zipgate element to init the component
var zipgateElement = document.getElementsByClassName('js-zipgate')[0];
var pageName = '';

if (window.Acr) {
  // Adding zipcode attribute before riot loading
  zipcode = window.Acr.zipgateComponent ? window.Acr.zipgateComponent.getZipcode() : '';
}

module.exports = main;

if (dealerElement) {
  if (zipcode) {
    zipgateElement.classList.remove('acr-zipgate--executed');
    zipgateElement.setAttribute('data-redirect', 'false');

    if (process.env.NODE_ENV !== 'production') {
      main.init();
    }
  } else if (window.Acr && window.Acr.zipgateComponent) {
    if (dealerElement.getAttribute('data-is-embedded-in-raq') === 'True') {
      pageName = 'raq standalone';
    } else {
      pageName = 'dealer locator results';
    }

    dealerElement.style.display = 'none';
    window.Acr.trackingObject = { Page: { page_name: pageName } };
    window.Acr.zipgateComponent.openZipgate();
  } else {
    main.init();
  }
}
